import React from 'react';
import { twMerge } from 'tailwind-merge';
import { UnstyledableDiv } from '../../types/component.types';
import { Button } from '../Button/Button';
import { Icon } from '../Icon/Icon';
import { Text } from '../Text/Text';
import { Content } from './SidePanelContent';

type SidePanelHeaderElement = React.ElementRef<'div'>;
type SidePanelHeaderProps = UnstyledableDiv & {
  onClose: () => void;
};

/**
 * Wrapper for the header section of SidePanel.
 */
// eslint-disable-next-line react-x/no-forward-ref -- TODO: Wait! Don't change this file without seeing if you can remove this disable. It was added during a bulk version update, but fixing it would leave the park nicer than you found it. (The ref goes to SidePanelContent's Content, not a DOM node, so Content must declare a ref prop of its own before or alongside this change.)
export const Header = React.forwardRef<
  SidePanelHeaderElement,
  SidePanelHeaderProps
>(({ children, onClose, ...props }, forwardedRef) => {
  return (
    <Content {...props} shouldFillContainer={false} ref={forwardedRef}>
      <div
        className={twMerge(
          'flex items-center w-full',
          children ? 'justify-between' : 'justify-end',
        )}
      >
        {children && (
          <Text as="h1" size="headingS">
            {children}
          </Text>
        )}
        <div className="ml-auto">
          <Button
            intent="ghost"
            size="small"
            onClick={onClose}
            aria-label="Close panel"
          >
            <Icon name="close" size="large" />
          </Button>
        </div>
      </div>
    </Content>
  );
});

Header.displayName = 'SidePanelHeader';
